<template>
    <span class="aurora-event-icon" :class="{ 'aurora-event-icon--custom': !iconName, 'aurora-event-icon--illustrated': !!iconName }">
        <AuroraArtIcon v-if="iconName" :name="iconName" />
        <img v-else :src="imageUrl" alt="">
    </span>
</template>

<script>
import AuroraArtIcon from './artIcon.vue'
import { eventIcons } from './icons'

export default {
    name: 'AuroraEventIcon',
    components: { AuroraArtIcon },
    props: {
        eventType: { type: String, default: '' },
        imageUrl: { type: String, default: '' }
    },
    computed: {
        iconName() {
            // Custom campaigns retain the image supplied by the API.
            return eventIcons[this.eventType] || ''
        }
    }
}
</script>
